var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoNdll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 56,
    viewBox: "0 0 40 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.262,
    x2: 0.5,
    y2: 1.386,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.062,
    stopColor: "#69ebd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.187,
    stopColor: "#56dbd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#27b4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#0597f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172a3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_nidos_de_lluvia",
    transform: "translate(-305 -7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6457",
    "data-name": "Rectangle 6457",
    width: 40,
    height: 56,
    transform: "translate(305 7)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19318",
    "data-name": "Path 19318",
    d: "M184.877,126.249c0,.072,0,.14,0,.21h0C184.874,126.389,184.874,126.319,184.877,126.249Zm39.61,0c0,.072,0,.14,0,.21h0C224.491,126.389,224.491,126.319,224.487,126.249Zm-39.61,0c0,.072,0,.14,0,.21h0C184.874,126.389,184.874,126.319,184.877,126.249Zm39.615.21h0c0-.07,0-.138,0-.21C224.491,126.319,224.491,126.389,224.492,126.459Zm-.756-27.025a.756.756,0,0,1,.756.757v26.269c0-.07,0-.14,0-.21,0,.072,0,.14,0,.21h0v.088a19.81,19.81,0,1,1-39.62,0v-.088h0c0-.07,0-.138,0-.21,0,.07,0,.14-.005.21V100.19a.757.757,0,0,1,.756-.757H198.25a.758.758,0,0,0,.609-.308c2.324-3.149,4.026-5.246,4.139-5.383l.711-.872a1.254,1.254,0,0,1,1.948,0l.711.872c.113.137,1.813,2.234,4.139,5.383a.757.757,0,0,0,.609.308ZM197.652,108.4c-1.492,2.246-2.8,4.362-3.912,6.321a1.259,1.259,0,0,0,.772,1.838,28.493,28.493,0,0,1,9.428,4.526,1.252,1.252,0,0,0,1.478,0,28.233,28.233,0,0,1,9.428-4.531,1.259,1.259,0,0,0,.776-1.837c-1.112-1.958-2.42-4.071-3.909-6.315-2.184-3.29-4.386-6.3-6.03-8.469a1.256,1.256,0,0,0-2,0C202.038,102.1,199.837,105.112,197.652,108.4Zm-8.438-3.869v6.522a.756.756,0,0,0,1.407.383q1.523-2.591,3.431-5.467.342-.514.681-1.016a.756.756,0,0,0-.627-1.179h-4.137A.756.756,0,0,0,189.215,104.533Zm6.355,26.749a15.362,15.362,0,0,0-4.172-1.941,1.257,1.257,0,0,0-1.564,1.551,15.488,15.488,0,0,0,2.888,5.466,1.257,1.257,0,0,0,2.18-.427,28.347,28.347,0,0,1,1.131-3.1A1.258,1.258,0,0,0,195.569,131.282Zm3.755-4.142q.56-.752,1.173-1.471a1.259,1.259,0,0,0-.278-1.876,24.14,24.14,0,0,0-8.259-3.377,1.253,1.253,0,0,0-1.412.767q-.413,1.028-.7,1.944a1.258,1.258,0,0,0,.967,1.609,19.662,19.662,0,0,1,6.83,2.716A1.254,1.254,0,0,0,199.324,127.14Zm8.988,3.046a19.67,19.67,0,0,1,10.235-5.453,1.255,1.255,0,0,0,.967-1.609q-.285-.915-.7-1.944a1.259,1.259,0,0,0-1.414-.769,24.313,24.313,0,0,0-18.943,19.233,1.253,1.253,0,0,0,.787,1.406,15.446,15.446,0,0,0,2.074.619,1.256,1.256,0,0,0,1.506-1.012A19.687,19.687,0,0,1,208.312,130.186Zm9.657-.843a15.545,15.545,0,0,0-10.5,10.512,1.258,1.258,0,0,0,1.559,1.559,15.546,15.546,0,0,0,10.5-10.514A1.256,1.256,0,0,0,217.969,129.343Zm.774-17.905a.756.756,0,0,0,1.407-.383v-6.521a.756.756,0,0,0-.756-.756h-4.139a.756.756,0,0,0-.627,1.179q.339.5.681,1.016Q217.216,108.841,218.742,111.437Z",
    transform: "translate(120.128 -84.458)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNdll);
export default __webpack_public_path__ + "static/media/ico_ndll.53bc745a946d400e2d7bd14c0bdddee9.svg";
export { ForwardRef as ReactComponent };